/** Stub for CDN bundle: fetch-based http */
export default {
  get: (url, opts) =>
    fetch(url, { ...opts, credentials: 'include' }).then((r) => r.json().then((data) => ({ data }))),
};
